export function debounce(cb, delay = 1000) {
    let timerId
    return (...args) => {
        clearTimeout(timerId)
        timerId = setTimeout(() => {
            cb(...args)
        }, delay)
    }
}
